import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext(null);
const THEME_STORAGE_KEY = 'app-theme';

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => localStorage.getItem(THEME_STORAGE_KEY) || "light");
    
    useEffect(() => {
        document.body.className = theme; 
        
        localStorage.setItem(THEME_STORAGE_KEY, theme);
        
    }, [theme]);

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === THEME_STORAGE_KEY && event.newValue) {
                setTheme(event.newValue);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
    

    const toggleTheme = (newTheme) => {
        setTheme(newTheme);
    };


    const value = {
        theme,
        toggleTheme 
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};
